import { useContext, useState } from "react";
import { ContextProviderWrapper } from "../../../../../components/Context";
import {
  CaretArrow,
  EarnedText,
  FormKib,
  FormKibVisual,
  PoolsListAction,
  PoolsStakingBottom,
  PoolsStakingContainer,
  PoolsStakingDesc,
  PoolsStakingHeader,
  PoolsStats,
  StakingBottomForm,
  StakingBottomReward,
  WrapperActionStake,
} from "../styled";
import web3 from "web3";
import {
  MyLiquidityWrapper,
  PoolInfoTitle,
  PoolsImage,
  PoolsInfo,
} from "../../../Liquidity/Tabs/Pools/styled";
import { convertFromWei } from "../../../../../utils/convertNumber";
import { CalendarOutlined, CaretDownOutlined } from "@ant-design/icons";
import { ButtonCommon } from "../../../../../Layout/styled";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import toast from "react-hot-toast";
import ABI_STAKING from "../../../../../constant/ABI/abiStaking.json";
import { Link } from "react-router-dom";
import { MAINNET_CHAIN_ID } from "../../../../../constant";
import Loading from "../../../../../components/Loading";
import { useChainId } from "wagmi";
import Value from "../../../../../components/Value";

const LiveItem = ({
  displayData,
  isExpanded,
  id,
  token0,
  token1,
  term,
  aprDummy,
  setOpenStake,
  setOpenUnStake,
  setOpenSchedule,
  setClickedId,
  fetchUserProfile,
  fetchPrices,
  userProfile,
  tokenPrices,
}: any) => {
  const { theme } = useContext(ContextProviderWrapper)!;
  const Web3 = new web3(window.ethereum);
  const { address }: any = useAppKitAccount();
  const chainId = useChainId();
  const { open } = useAppKit();
  const [isLoading, setIsLoading] = useState(false);

  const handleWithdraw = async (value: any) => {
    setIsLoading(true);
    try {
      const contract = new Web3.eth.Contract(
        ABI_STAKING,
        displayData[id - 1]?.contract
      );
      await contract.methods
        .withdraw(value)
        .send({ from: address })
        .then(async () => {
          setIsLoading(false);
          await fetchUserProfile();
          await fetchPrices();
          toast.success("Harvest successfully");
        })
        .catch((err: any) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    } catch (error: any) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <>
      <PoolsStakingHeader className={isExpanded ? "active" : ""}>
        <PoolsStakingContainer>
          <PoolsStakingDesc>
            <PoolsImage className={theme}>
              <div>
                <figure>
                  <img
                    src={token0.img || "/static/default-token-image.png"}
                    alt="icon"
                    onError={(e) =>
                      (e.currentTarget.src = "/static/default-token-image.png")
                    }
                  />
                </figure>
              </div>
              <div>
                <figure>
                  <img
                    src={token1.img || "/static/default-token-image.png"}
                    alt="icon"
                    onError={(e) =>
                      (e.currentTarget.src = "/static/default-token-image.png")
                    }
                  />
                </figure>
              </div>
            </PoolsImage>
            <PoolsInfo className={theme}>
              <p>
                {token0?.name} / {token1?.name}
              </p>
              <PoolsListAction className={theme}>
                {displayData[id - 1]?.socials.map((item: any, index: any) => (
                  <li
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <Link to={item.link} target="_blank" rel="noreferer">
                      <figure>
                        <img
                          src={theme === "dark" ? item.icon : item.iconLight}
                          alt={item.id.toString()}
                        />
                      </figure>
                    </Link>
                  </li>
                ))}
              </PoolsListAction>
            </PoolsInfo>
          </PoolsStakingDesc>
          <PoolsStats>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
              }}
            >
              <PoolInfoTitle>APY</PoolInfoTitle>
              <Value
                unitafter="%"
                value={
                  userProfile[id]?.apr !== 0 ? userProfile[id]?.apr : aprDummy
                }
              />
            </p>
            <p>
              <PoolInfoTitle>Lock-up term</PoolInfoTitle>
              <Value unitafter="Days" decimals={0} value={term} />
            </p>
            <p>
              <PoolInfoTitle>Total staked</PoolInfoTitle>
              <Value
                unitafter="KIB"
                value={
                  Number(
                    convertFromWei(
                      userProfile[id]?.balanceOf,
                      userProfile[id]?.detailsToken?.decimals || 18
                    )
                  ) || 0
                }
              />
            </p>
          </PoolsStats>
        </PoolsStakingContainer>
        <MyLiquidityWrapper className={theme}>
          <PoolInfoTitle>Earned</PoolInfoTitle>
          <EarnedText>
            <Value
              value={Number(
                `${convertFromWei(
                  userProfile[id]?.pendingReward[0],
                  userProfile[id]?.detailsToken?.decimals
                )}`
              )}
            />
            <img
              style={{ maxWidth: "20px" }}
              src={`/assets/token/${token1?.name}.png`}
              alt="icon"
            />
          </EarnedText>
          <CaretArrow className={isExpanded ? "active" : ""}>
            <CaretDownOutlined />
          </CaretArrow>
        </MyLiquidityWrapper>
      </PoolsStakingHeader>
      <PoolsStakingBottom
        onClick={(e) => e.stopPropagation()}
        className={isExpanded ? "active" : ""}
      >
        <StakingBottomReward className={theme}>
          <p>Total Token Locked</p>
          <p>
            <Value
              value={
                Number(
                  convertFromWei(
                    userProfile[id]?.balanceOf,
                    userProfile[id]?.detailsToken?.decimals || 18
                  )
                ) || 0
              }
            />
            {token0?.name}
          </p>
        </StakingBottomReward>
        <StakingBottomForm className={theme}>
          <FormKib style={{ paddingBottom: "22px" }}>
            <div>
              <p>{token1?.name} Earned</p>
            </div>
            <div>
              <FormKibVisual>
                <Value
                  value={Number(
                    `${convertFromWei(
                      userProfile[id]?.pendingReward[0],
                      userProfile[id]?.detailsToken?.decimals
                    )}` || 0
                  )}
                />
                <img
                  style={{ maxWidth: "20px" }}
                  src={`/assets/token/${token1?.name}.png`}
                  alt="icon"
                />
              </FormKibVisual>
              <p>
                <Value
                  unit="$"
                  value={
                    Number(tokenPrices[id]?.reward) *
                      Number(
                        convertFromWei(
                          userProfile[id]?.pendingReward[0],
                          userProfile[id]?.detailsToken?.decimals
                        )
                      ) || 0
                  }
                />
              </p>
            </div>
          </FormKib>
          <ButtonCommon
            onClick={() => {
              handleWithdraw(true);
            }}
            disabled={
              !address ||
              chainId !== MAINNET_CHAIN_ID ||
              isLoading ||
              Number(
                convertFromWei(
                  userProfile[id]?.pendingReward[0],
                  userProfile[id]?.detailsToken?.decimals
                )
              ) === 0
            }
          >
            <Loading title="Harvest" status={isLoading} />
          </ButtonCommon>
        </StakingBottomForm>
        <StakingBottomForm className={theme}>
          <FormKib>
            <div>
              <EarnedText>
                {token0?.name} Staked
                <CalendarOutlined
                  onClick={() => {
                    setOpenSchedule(true);
                    setClickedId(id);
                  }}
                  style={{
                    fontSize: "16px",
                  }}
                />
              </EarnedText>
              <WrapperActionStake>
                <ButtonCommon
                  style={{ marginTop: "0px" }}
                  onClick={() => {
                    setOpenUnStake(true);
                    setClickedId(id);
                  }}
                  disabled={
                    !address ||
                    chainId !== MAINNET_CHAIN_ID ||
                    Number(
                      `${convertFromWei(
                        userProfile[id]?.info.amount,
                        userProfile[id]?.detailsToken?.decimals
                      )}`
                    ) === 0
                  }
                >
                  Unstake
                </ButtonCommon>
                <ButtonCommon
                  style={{ marginTop: "0px" }}
                  onClick={() => {
                    setOpenStake(true);
                    setClickedId(id);
                  }}
                  disabled={!address || chainId !== MAINNET_CHAIN_ID}
                >
                  +
                </ButtonCommon>
              </WrapperActionStake>
            </div>
            <div>
              <FormKibVisual>
                <Value
                  value={Number(
                    `${convertFromWei(
                      userProfile[id]?.info?.amount,
                      userProfile[id]?.detailsToken?.decimals
                    )}` || 0
                  )}
                />
                <img
                  style={{ maxWidth: "20px" }}
                  src={`/assets/token/${token0?.name}.png`}
                  alt="icon"
                />
              </FormKibVisual>
              <p>
                <Value
                  unit="$"
                  value={
                    Number(tokenPrices[id]?.stake) *
                      Number(
                        convertFromWei(
                          userProfile[id]?.info.amount,
                          userProfile[id]?.detailsToken?.decimals
                        )
                      ) || 0
                  }
                />
              </p>
            </div>
          </FormKib>
          <ButtonCommon
            disabled={address}
            onClick={() => {
              if (!address) {
                open();
              }
            }}
          >
            {address ? "Connected" : "Connect Wallet"}
          </ButtonCommon>
        </StakingBottomForm>
      </PoolsStakingBottom>
    </>
  );
};

export default LiveItem;
